export const TCItemEvalPeriodDaily = 'daily'
export const TCItemEvalPeriodWeekly = 'weekly'
export const TCItemEvalPeriodMonthly = 'monthly'
export const TCItemEvalPeriodQuarterly = 'quarterly'
export const TCItemEvalPeriodEmpty = 'empty'

export const TCItemEvaluationSourceInbound = 'inbound'
export const TCItemEvaluationSourceBuyin = 'buy-in'

export const DistributorFeeStatusCreated = 'created'
export const DistributorFeeStatusFinanceAdjusted = 'finance_adjusted'
export const DistributorFeeStatusFinanceConfirmed = 'finance_confirmed'
export const DistributorFeeSourceApproved = 'source_approved'
export const DistributorFeeSourceRejected = 'source_rejected'

export const TCI_EVALUATION_SOURCE_COLOR_MAPPING = {
  [TCItemEvaluationSourceInbound]: 'magenta',
  [TCItemEvaluationSourceBuyin]: 'gold',
}

export const TCI_EVALUATION_SOURCE_TEXT_MAPPING = {
  [TCItemEvaluationSourceInbound]: 'Inbound',
  [TCItemEvaluationSourceBuyin]: 'Buy-in',
}

export const StatusEditable = [
  DistributorFeeSourceApproved,
  DistributorFeeSourceRejected,
  DistributorFeeStatusFinanceAdjusted,
]
export const StatusChangeAble = [
  DistributorFeeStatusCreated,
  DistributorFeeStatusFinanceAdjusted,
]

export const DISTRIBUTOR_FEE_STATUS_COLOR_MAPPING = {
  [DistributorFeeStatusCreated]: 'blue',
  [DistributorFeeStatusFinanceAdjusted]: 'orange',
  [DistributorFeeStatusFinanceConfirmed]: 'green',
  [DistributorFeeSourceApproved]: 'cyan',
  [DistributorFeeSourceRejected]: 'red',
}

export const TCI_EVALUATION_SOURCE_SELECT = [
  TCItemEvaluationSourceInbound,
  TCItemEvaluationSourceBuyin,
]
export const TCI_EVALUATION_PERIOD_SELECT = [
  TCItemEvalPeriodEmpty,
  TCItemEvalPeriodDaily,
  TCItemEvalPeriodWeekly,
  TCItemEvalPeriodMonthly,
  TCItemEvalPeriodQuarterly,
]
export const DISTRIBUTOR_FEE_MAPPING = [
  DistributorFeeStatusCreated,
  DistributorFeeStatusFinanceAdjusted,
  DistributorFeeStatusFinanceConfirmed,
  DistributorFeeSourceApproved,
  DistributorFeeSourceRejected,
]
